<template>
  <div class="guide ml-1 mr-1">
    <div class="col-md-3 float-left pl-0 pr-0">
      <div class="comp-title">
        <div class="left">
          <h1 class="text-uppercase color-text-bold">
            <img src="../../../../static/img/comp-title.png"/>
            Hướng dẫn
          </h1>
        </div>
      </div>
      <div style="clear: both"></div>

      <div class="activeTab text-left" @click="showTabList">
        <span class="fa fa-caret-down"></span> {{ activeTabDisplayName }}
      </div>

      <div class="sidenav text-left" v-show="showTab">
        <a v-for="tab in tabs" class="tablinks"
           :class="{ active : tab.name == activeTabName }"
           @click="showCurrentTab(tab.name, tab.displayName)"
        >
          {{ tab.displayName }}
        </a>
      </div>
    </div>
    <div class="col-md-9 float-right content pr-0 pl-0">
      <h4 class="bg-color-green padd-10 text-uppercase mg-0" id="titleQA"></h4>
      <div v-for="tab in tabs" class="tabcontent row item text-justify" :class="{ active : tab.name == activeTabName }">
        <h3 class="font-size-22 font-weight-bold">{{ tab.displayName }}</h3>
        <div v-html="tab.content" class="text-justify"></div>
      </div>
    </div>
    <div style="clear: both;"></div>
    <partner></partner>
  </div>
</template>

<script>
  import Partner from '../../home/wap/Partner'

  export default {
    name: "Guide",
    components: {
      "partner": Partner
    },
    data () {
      return {
        showTab: false,
        activeTabName: null,
        activeTabDisplayName: null,
        tabs: [
          /*{
            "name": "tab1",
            "displayName": "Dịch vụ tổng đài Quà tặng âm nhạc",
            "content": "Nội dung dịch vụ tổng đài Quà tặng âm nhạc"
          },
          {
            "name": "tab2",
            "displayName": "Chính sách riêng tư",
            "content": "Nội dung chính sách riêng tư"
          },
          {
            "name": "tab3",
            "displayName": "Câu hỏi thường gặp",
            "content": "Nội dung câu hỏi thường gặp"
          },
          {
            "name": "tab4",
            "displayName": "Liên hệ",
            "content": "Nội dung liên hệ"
          }*/
        ],
        tabsTemp: []
      }
    },
    mounted () {
      /*this.activeTabName = this.tabs[0].name;
      this.activeTabDisplayName = this.tabs[0].displayName;*/
    },
    methods: {
      showTabList(){
        if(this.showTab){
          this.showTab = false;
        } else {
          this.showTab = true;
        }
      },
      showCurrentTab(tabName, displayName){
        this.showTab = false;
        this.activeTabDisplayName = displayName;
        this.activeTabName = tabName;
        this.$router.push({ path: this.$router.path, query: { tab: tabName } });
      },
      getContent(){
        axios.post(api.guideList, { categoryCode: this.settings.categoryCodeGuide })
          .then(response => {
            var res = response.data.result;
            res.forEach(item => {
              this.tabs.push({
                "name": item.alias,
                "displayName": item.title,
                "content": item.content
              });

              this.tabsTemp[item.alias] = item.title;
            });

            return this.tabs;
          })
          .then(response => {
            //this.activeTabName = response[0].name;
            //this.activeTabDisplayName = response[0].displayName;

            response.forEach(item => {
              if(item.name.indexOf("gioi-thieu") > -1){
                this.activeTabName = item.name;
                this.activeTabDisplayName = item.displayName;
              }
            });

            if(this.$route.query.tab && this.$route.query.tab != undefined){
              this.activeTabName = this.$route.query.tab;
              this.activeTabDisplayName = this.tabsTemp[this.$route.query.tab];
            }
          })
          .catch(e => {
            console.log("Guide----");
            console.log(e);
          });
      }
    },
    watch: {
      "$route.path": {
        handler: function (val) {
          this.getContent();
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .activeTab{
    background-color: #00a4e9;
    padding: 0.5rem 0.5rem;
    color: #fff;
  }
  .sidenav{
    transition: 2s;
  }
  .sidenav .tablinks{
    margin: 0 !important;
  }
  .tablinks.active{
    background-color: #0183ba !important;
  }
  .tabcontent{
    display: none;
  }
  .tabcontent.active{
    display: block !important;
  }
  .comp-title{
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/guide/wap/Guide.vue